import React from 'react'

export class RatingInputItem extends React.Component {
  render () {
    const { field, checked, label, value, onChange } = this.props
    const classes = ['rating-input__options__item']
    if (checked) {
      classes.push('rating-input__options__item--checked')
    }
    return (
      <label className={classes.join(' ')}>
        <input
          type="radio"
          name={field}
          value={value}
          checked={checked}
          onChange={onChange}
        />
        <span>{label}</span>
      </label>
    )
  }
}

export class RatingInput extends React.Component {
  state = {}

  render () {
    const { field, label, value, options } = this.props
    const items = options.map((option, index) => {
      const checked = +option.value === +value
      return (
        <RatingInputItem
          key={index}
          field={field}
          checked={checked}
          value={option.value}
          label={option.label}
          onChange={this._handleChange}
        />
      )
    })

    return (
      <div className="rating-input">
        <label
          className="rating-input__label"
        >{label}</label>
        <div className="rating-input__options">
          {items}
        </div>
      </div>
    )
  }

  _handleChange = e => {
    const { field, onChange } = this.props
    const value = +e.target.value
    onChange({ field, value })
  }
}
